export const ShopifyConstants = window.ShopifyConstants;
